import { Parallax } from "@react-spring/parallax";
import ConnectSection from "./ConnectSection";
import { Box } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export default {
  component: ConnectSection,
};

export const Primary = {
  render: (args) => (
    <Box sx={{ padding: { xs: 2, md: 4 } }}>
      <Parallax pages={1}>
        <ConnectSection {...args} />
      </Parallax>
    </Box>
  ),
  args: {
    offset: 0,
    speed: 0.3,
    connectCards: [
      {
        Icon: GitHubIcon,
        title: "GitHub",
        profile: "Jacee94",
        inView: true,
        link: "https://github.com/Jacee94",
      },
      {
        Icon: LinkedInIcon,
        title: "LinkedIn",
        profile: "Jace-edwards94",
        inView: true,
        link: "https://www.linkedin.com/in/jace-edwards94/",
      },
    ],
  },
};
